<div *ngIf="selectedOption" data-cy="deal-status-picker" (click)="$event.stopPropagation()" class="deal-status-picker">
  <button data-cy="deal-status-display-current" mat-flat-button (click)="select.open()" [ngClass]="'bg-' + selectedOption.stage">
    <mat-select data-cy="status-select-list" #select [value]="selectedOption" (selectionChange)="handleChange($event.value)" panelClass="deal-status-picker">
      <mat-optgroup data-cy="deal-status-picker-options-group-header" *ngFor="let group of optionGroups" [label]="group.label" [ngClass]="'text-' + group.stage">
        <mat-option data-cy="deal-status-picker-options-list" [style.font-weight]="bold" *ngFor="let option of group.options" [value]="option">
          <span data-cy="deal-status-display" *ngIf="option">{{ option.display }}</span>
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </button>
</div>
